import React from "react";
import AmCharts from "@amcharts/amcharts3-react";

const DrivingCguChart = ({ data, cguLimit, lang }) => {
  let dataProvider = [...data];

  // From smallest to biggest
  dataProvider.sort(function(a, b) {
    return a.Puntos - b.Puntos;
  });

  let config = {
    type: "serial",
    addClassNames: true,
    pathToImages: "https://cdn.amcharts.com/lib/3/images/",
    language: lang._code,
    categoryField: "Descripcion",
    autoMargins: false,
    marginRight: 20,
    marginLeft: 120,
    marginTop: 20,
    marginBottom: 40,
    mouseWheelZoomEnabled: false,
    zoomOutOnDataUpdate: true,
    startDuration: 0,
    categoryAxis: {
      gridPosition: "start",
      labelFunction: label => label.substr(0, 10)
    },
    trendLines: [],
    graphs: [
      {
        fillAlphas: 1,
        lineAlpha: 0,
        id: "cgu-graph",
        type: "column",
        valueField: "Puntos"
        //"fixedColumnWidth": 50
      }
    ],
    guides: [
      {
        id: "cgulimit",
        value: cguLimit,
        lineColor: "#ff0000",
        fillColor: "#ff0000",
        lineThicknes: 1,
        lineAlpha: 1,
        fillAlpha: 0,
        label: lang.LimiteCgu,
        boldLabel: false,
        position: "left",
        above: true,
        inside: false
      }
    ],
    valueAxes: [
      {
        id: "ValueAxis-1",
        includeGuidesInMinMax: true
      }
    ],
    dataProvider: dataProvider,
    allLabels: [],
    path: "http://cdn.amcharts.com/lib/3/",
    listeners: [
      {
        event: "drawn",
        method: function() {
          var guideText = document.querySelector(
            ".amcharts-guide-cgulimit tspan"
          );
          if (guideText) {
            guideText.setAttribute("x", -20);
          }
        }
      }
    ]
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "100%"
      }}
      options={config}
    />
  );
};

export default DrivingCguChart;



// WEBPACK FOOTER //
// ./src/charts/DrivingCguChart/DrivingCguAmcharts.js